<template>
  <!-- Main sidebar -->
  <div v-if="!staffControl" class="menu">
    <v-navigation-drawer v-model="drawer" :mini-variant.sync="mini" hide-overlay stateless v-click-outside="cerrarNav">
      <v-toolbar flat class="transparent" style="height: 56px;">
        <v-list class="pa-0">
          <v-list-tile avatar @click.stop="mini = !mini">
            <v-list-tile-avatar tile>
              <v-img :src="require('../assets/logo.svg')" aspect-ratio="1" contain></v-img>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="text-uppercase font-weight-bold title pt-1"></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon @click.stop="mini = !mini" class="ma-0 primary-color ">
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list v-if="$store.getters.isLoggedIn" class="pt-0">
        <v-divider class="ma-0"></v-divider>
        <v-list-tile v-if="permitido('MOBILESTORE.BI') && !isSys4Conjunto()" @click.stop="mini = !mini">
          <v-list-tile-action>
            <v-icon>stacked_bar_chart</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title href="javascript:" @click="irA('dashboard', 'business')"> Business Intelligence</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-group v-if="permitido('MOBILESTORE.TABLAS')" v-show="false">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-action @click.stop="mini = !mini">
                <v-icon>store</v-icon>
              </v-list-tile-action>
              <a href="javascript:">
                <v-list-tile-content>
                  <v-list-tile-title> {{ $t('lang.sidebar.tablas') }}</v-list-tile-title>
                </v-list-tile-content>
              </a>
            </v-list-tile>
          </template>

          <v-list-tile v-if="permitido('MOBILESTORE.TABLAS.GENERAL')" class="col-12">
            <a href="javascript:" @click="irA('tablageneral')">
              <v-list-tile-title>Tabla general</v-list-tile-title>
            </a>
          </v-list-tile>

          <v-list-tile v-if="permitido('MOBILESTORE.TABLAS.STOCKDISPONIBLE')" class="col-12">
            <a href="javascript:" @click="irA('tablastock')">
              <v-list-tile-title>{{ $t('lang.sidebar.tabla.tablastock') }}</v-list-tile-title>
            </a>
          </v-list-tile>

          <v-list-tile v-if="permitido('MOBILESTORE.TABLAS.PEDIDO')" class="col-12">
            <a href="javascript:" @click="irA('tablapedido')">
              <v-list-tile-title>{{ $t('lang.sidebar.tabla.tablapedido') }}</v-list-tile-title>
            </a>
          </v-list-tile>

          <v-list-tile v-if="permitido('MOBILESTORE.TABLAS.ALBARAN')" class="col-12">
            <a href="javascript:" @click="irA('tablaalbaran')">
              <v-list-tile-title> {{ $t('lang.sidebar.tabla.tablaalbaran') }} </v-list-tile-title>
            </a>
          </v-list-tile>

          <v-list-tile v-if="permitido('MOBILESTORE.TABLAS.RSVSTOCK')" class="col-12">
            <a href="javascript:" @click="irA('tablareservastock')">
              <v-list-tile-title> {{ $t('lang.sidebar.tabla.tablareservastock') }} </v-list-tile-title>
            </a>
          </v-list-tile>

          <v-list-tile v-if="permitido('MOBILESTORE.TABLAS.RSVCOMPRA')" class="col-12">
            <a href="javascript:" @click="irA('tablareservacompra')">
              <v-list-tile-title> {{ $t('lang.sidebar.tabla.tablareservacompra') }} </v-list-tile-title>
            </a>
          </v-list-tile>

          <v-list-tile v-if="permitido('MOBILESTORE.TABLAS.ODT')" class="col-12">
            <a href="javascript:" @click="irA('tablaodt')">
              <v-list-tile-title> {{ $t('lang.sidebar.tabla.tablaodt') }} </v-list-tile-title>
            </a>
          </v-list-tile>
        </v-list-group>

        <v-list-group v-if="permitido('MOBILESTORE.GESTIONTIENDA') && !$store.getters.isAdminSYS4">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-action @click.stop="mini = !mini">
                <v-icon>store</v-icon>
              </v-list-tile-action>
              <a href="javascript:" @click="irA('')">
                <v-list-tile-content>
                  <v-list-tile-title>Gestión tienda</v-list-tile-title>
                </v-list-tile-content>
              </a>
            </v-list-tile>
          </template>

          <v-list-tile v-if="permitido('MOBILESTORE.GESTIONTIENDA.CALENDARIO') && !$store.getters.isAdminSYS4" @click.stop="mini = !mini">
            <v-list-tile-action @click.stop="mini = !mini">
              <v-icon>event</v-icon>
            </v-list-tile-action>
            <a href="javascript:" @click="irA('calenlab', 'tien')">
              <v-list-tile-content>
                <v-list-tile-title>Calendario Laboral</v-list-tile-title>
              </v-list-tile-content>
            </a>
          </v-list-tile>
          <!-- DEPRECATED -->
          <!-- <v-list-tile v-if="permitido('MOBILESTORE.GESTIONTIENDA.CITAPREVIA') && !isSys4Conjunto()" @click.stop="mini = !mini">
            <v-list-tile-action>
              <v-icon>schedule</v-icon>
            </v-list-tile-action>
            <a href="javascript:" @click="irA('citaprevia', 'tien')">
              <v-list-tile-content>
                <v-list-tile-title>Cita previa</v-list-tile-title>
              </v-list-tile-content>
            </a>
          </v-list-tile> -->
        </v-list-group>
        <v-list-tile @click.stop="mini = !mini" v-if="permitido('MOBILESTORE.CONTROLUSER') || $store.getters.isAdminSYS4">
          <v-list-tile-action>
            <v-icon>group</v-icon>
          </v-list-tile-action>
          <a href="javascript:" @click="irA('personal', 'usu')">
            <v-list-tile-content>
              <v-list-tile-title>Control usuario</v-list-tile-title>
            </v-list-tile-content>
          </a>
        </v-list-tile>

        <v-list-tile v-if="permitido('MOBILESTORE.LOOKS') && !$store.getters.isAdminSYS4" v-show="true" @click.stop="mini = !mini">
          <v-list-tile-action>
            <v-icon>checkroom</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <a href="javascript:" @click="irA('looks', 'look')">
              <v-list-tile-title>Looks</v-list-tile-title>
            </a>
          </v-list-tile-content>
        </v-list-tile>
        <!--<v-list-group v-if="permitido('MOBILESTORE.LOOKS')" v-show="true"  >
      <template v-slot:activator>            
        <v-list-tile  >  
          <v-list-tile-action @click.stop="mini = !mini">
            <v-icon>checkroom</v-icon>
          </v-list-tile-action >
          <a href="javascript:" @click="irA('')" > 
            <v-list-tile-content>
              <v-list-tile-title>Looks</v-list-tile-title>
            </v-list-tile-content>
          </a> 
        </v-list-tile>
      </template>       
      
      <v-list-tile @click.stop="mini = !mini">
        <v-list-tile-action >
          <v-icon>loyalty</v-icon>
        </v-list-tile-action >
        <a href="javascript:" @click="irA('looks','look')">
          <v-list-tile-content>
            <v-list-tile-title>Look</v-list-tile-title>
          </v-list-tile-content>
        </a>
      </v-list-tile>
      
      <v-list-tile @click.stop="mini = !mini" v-if="permitido('MOBILESTORE.LOOKS.CRUD')">
        <v-list-tile-action  >
          <v-icon>content_cut</v-icon>
        </v-list-tile-action >
        <a href="javascript:" @click="irA('lookcreator','look')">
          <v-list-tile-content>
            <v-list-tile-title>Look creator</v-list-tile-title>
          </v-list-tile-content>
        </a>
      </v-list-tile>                 
    </v-list-group>-->

        <v-list-group v-if="permitido('MOBILESTORE.WORKSPACE')" v-show="false">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-action @click.stop="mini = !mini">
                <v-icon>apartment</v-icon>
              </v-list-tile-action>
              <a href="javascript:" @click="irA('')">
                <v-list-tile-content>
                  <v-list-tile-title>Workspace</v-list-tile-title>
                </v-list-tile-content>
              </a>
            </v-list-tile>
          </template>

          <v-list-tile @click.stop="mini = !mini" v-if="permitido('MOBILESTORE.WORKSPACE.WEBLINKS')">
            <v-list-tile-action>
              <v-icon>link</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title href="javascript:" @click="irA('weblinks')">Web links</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click.stop="mini = !mini" v-if="permitido('MOBILESTORE.WORKSPACE.NOTAS')">
            <v-list-tile-action>
              <v-icon>summarize</v-icon>
            </v-list-tile-action>
            <a href="javascript:" @click="irA('notas')">
              <v-list-tile-content>
                <v-list-tile-title>Notas</v-list-tile-title>
              </v-list-tile-content>
            </a>
          </v-list-tile>
        </v-list-group>
        <v-list-tile @click.stop="mini = !mini" v-show="false">
          <v-list-tile-action>
            <i class="icon-instagram"></i>
          </v-list-tile-action>
          <v-list-tile-content>
            <a href="javascript:" @click="irA('instagram')">
              <v-list-tile-title>Instagram</v-list-tile-title>
            </a>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="permitido('MOBILESTORE.TIENDA') && !$store.getters.isAdminSYS4" @click.stop="mini = !mini">
          <v-list-tile-action>
            <v-icon>shopping_cart</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title href="javascript:" @click="irA('tienda')">Tienda</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="permitido('MOBILESTORE.CLIENTELING') && !$store.getters.isAdminSYS4" @click.stop="mini = !mini" v-show="false">
          <v-list-tile-action>
            <v-icon>person_pin_circle</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title href="javascript:" @click="irA('listaclientes')">Clienteling</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-show="true" v-if="permitido('MOBILESTORE.TIMELINE') && !isSys4Conjunto()" @click.stop="mini = !mini">
          <v-list-tile-action>
            <v-icon>dvr</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title href="javascript:" @click="irA('timeline')">TimeLine</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- <v-list-tile v-show="true" v-if="permitido('MOBILESTORE.INFORMES') && !isSys4Conjunto()" @click.stop="mini = !mini"> -->
        <v-list-tile v-show="true" @click.stop="mini = !mini">
          <v-list-tile-action>
            <v-icon>description</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title href="javascript:" @click="irA('informes')">Informes</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="mt-auto"  @click.stop="mini = !mini">
          <v-list-tile-action>
            <v-icon>power_settings_new</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title @click="irA('logout')">Desconectar</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
  <!-- /main sidebar -->
</template>
<script>
export default {
  data() {
    return {
      listaelementos: ['business', 'tien', 'usu', 'look', 'workspace', 'insta', 'tienda', 'cliente', 'time', 'lookcliente'],
      mostrar: true,
      drawer: true,
      items: [
        { title: 'Home', icon: 'dashboard' },
        { title: 'About', icon: 'question_answer' },
      ],
      mini: true,
      right: null,
    };
  },
  created() {
    // console.log(this.$store.getters.getAcl);
  },
  computed: {
    staffControl() {
      return this.$store.getters.isStaffControl;
    },
  },
  methods: {
    irA(direccion) {
      if (direccion != '') {
        this.$router.push({ name: direccion });
      }
    },
    cerrarNav() {
      this.mini = true
    }
  },
};
</script>
